export default __webpack_public_path__ + "static/media/AppleStore.30a0002d.svg";